import React from 'react';
import { useTranslation } from 'react-i18next';
import {
    NotCorrectVerificationBannerContainer,
    TypographyContainer,
} from '@modules/dashboard/pages/kyc/docs-verification/docs-verification-page/docs-verification-steps/start/not-correct-verification-banner/styles';

export const NotCorrectVerificationBanner = () => {
    const { t } = useTranslation();

    return (
        <NotCorrectVerificationBannerContainer>
            <TypographyContainer tag='div' variant='h3'>
                {t('docVerificationWidget.notCorrectVerification.text')}
            </TypographyContainer>
        </NotCorrectVerificationBannerContainer>
    );
};
